<template>
  <div class="modal fade" id="cancelModal" tabindex="-1" role="dialog" style="display: none;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" id="closeCancelModal" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
          <h4 class="modal-title text-danger" id="forgot_ModalLabel"><i class="fa fa-ban mr-5"></i>{{'cancel_order_item' | translate}}</h4>
        </div>
        <div class="modal-body">
          <h4>{{'cancel_item_modal_text_header' | translate}}</h4>
          <p>{{'cancel_item_modal_text_body' | translate}}</p>
          <p class="text-danger"><i class="fa fa-warning mr-5"></i>{{'return_mini_message' | translate}}</p>
          <p class="margin"></p>
          <div class="row">
            <div class="col-xs-12">
              <label class="pull-left">{{'reason_cancel' | translate}}:</label>
              <br/>
              <select v-model="selected" class="form-control">
                <option class="danger" value="out_of_stock">{{'out_of_stock' | translate}}</option>
                <option class="danger" value="article_has_defect">{{'article_has_defect' | translate}}</option>
                <option class="danger" value="prior_sale">{{'prior_sale' | translate}}</option>
                <option class="danger" value="fraud">{{'fraud' | translate}}</option>
                <option class="danger" value="customer_cancellation">{{'customer_cancellation' | translate}}</option>
                <option class="danger" value="accommodation">{{'accommodation' | translate}}</option>
              </select>
            </div>
          </div>
          <div class="row pt-10">
            <div class="col-xs-12">
              <label class="pull-left">{{'commentary' | translate}}:</label>
              <textarea class="form-control" v-model="message"></textarea>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-app no-margin btn-outline pull-left" data-dismiss="modal"><span class="fa fa-times"></span>Abbrechen</button>
          <button :disabled="message === '' || selected === ''" @click="$emit('action', [selected, message])" type="button" class="btn btn-app no-margin btn-success" data-dismiss="modal"><span class="fa fa-save"></span>{{'confirm' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['action', 'reason'],
  data () {
    return {
      selected: this.reason,
      message: ''
    }
  },
  methods: {
  },
  mounted () {
    this.$nextTick(() => {
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tools/Modals/CancelModal.vue